import React from "react";
import LoadingScreen from "../../../utils/LoadingScreen";
import { formatDateTime } from "../../../utils/dateFormatter";

const CampaigningCharges = ({
  campaigns = [],
  whatsappNumbers = [],
  loading,
  selectedNumber,
  onNumberChange,
}) => {
  const twoDecimal = (v) => Number(v || 0).toFixed(2);

  const validWhatsappNumbers = whatsappNumbers.filter(
    (num) => num?.phone_no_id,
  );

  const sortedCampaigns = [...campaigns].sort((a, b) => {
    return new Date(b.indate) - new Date(a.indate);
  });

  return (
    <>

    <div className="h-full flex flex-col overflow-hidden">
      <div className="p-3 montserrat-font-1">
        <label className="block text-sm font-medium mb-1">
          WhatsApp Number
        </label>

        <select
          className="border px-3 py-1 rounded w-80"
          value={selectedNumber || ""}
          onChange={(e) => onNumberChange(e.target.value)}
          disabled={validWhatsappNumbers.length <= 1}
        >
          {validWhatsappNumbers.length === 0 ? (
            <option value="">No WhatsApp Number</option>
          ) : (
            validWhatsappNumbers.map((num, i) => (
              <option key={i} value={String(num.phone_no_id)}>
                {num.phone_no || "NA"} ({num.phone_no_id})
              </option>
            ))
          )}
        </select>
      </div>

  <div className="flex-1 min-h-0 overflow-hidden">
  <div className="h-full overflow-y-auto overflow-x-auto">
    <table className="w-full text-sm montserrat-font-1">
        <thead className="sticky top-0 z-20 bg-green-200 shadow-sm montserrat-font-1">
          <tr>
            <th className="p-3">S.No.</th>
            <th className="p-3">Campaign ID</th>
            <th className="p-3">Name</th>
            <th className="p-3">Template</th>
            <th className="p-3">Created On</th>
            <th className="p-3">Submitted</th>
            <th className="p-3">Cost</th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan="7" className="text-center py-10">
                <LoadingScreen text="Loading data..." />
              </td>
            </tr>
          ) : sortedCampaigns.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center py-6 text-gray-500">
                No Records Found
              </td>
            </tr>
          ) : (
            sortedCampaigns.map((item, i) => (
              <tr key={item.id || i} className="border-b text-center">
                <td className="p-2">{i + 1}</td>

                <td className="p-2 font-semibold">ID-{item.id}</td>

                <td className="p-2">{item.campaign_name || "NA"}</td>

                <td className="p-2">{item.template_id || "NA"}</td>

                <td className="p-2">
  {formatDateTime(item.indate, true)}
</td>

                <td className="p-2">{item.submitted ?? item.sent ?? 0}</td>

                <td className="p-2 font-semibold">
                  ₹ {twoDecimal(item.estimatedCost)}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      </div>
      </div>
    </div>
    </>
  );
};

export default CampaigningCharges;
